<ng-container *transloco="let t">
  @for (label of labels; track labelTracker(label)) {
    <app-item-label [label]="label" [itemType]="projectItemType"></app-item-label>
  }
  @if (hiddenLabels.length) {
    <div [matTooltip]="hiddenLabelsTooltip">
      {{ t('project.project-details-table.labels-n-more', { count: hiddenLabels.length }) }}
    </div>
  }
</ng-container>
